import _typeof from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/typeof";

var _store$get, _store$get$;

import "core-js/modules/es6.array.find.js";
import { store } from "../store";
import messages from 'src/i18n';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
var i18n = new VueI18n({
  locale: ((_store$get = store.get('surveys/surveys')) === null || _store$get === void 0 ? void 0 : (_store$get$ = _store$get[0]) === null || _store$get$ === void 0 ? void 0 : _store$get$.templateLocale) || 'en-gb',
  fallbackLocale: 'en-gb',
  messages: messages
});
export default (function (_ref) {
  var app = _ref.app;
  // Set i18n instance on app
  app.i18n = i18n;
});
/**
 * Provides the i18n'd text associated with a customisable lang key associated
 * with a survey, rather than static i18n'd text.
 *
 * @param {String} key
 * @param {String} defaultText
 *
 * @returns {String}
 */

function lang(key) {
  var _survey;

  var defaultText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var surveyInProgress = store.get('surveys/surveyInProgress');

  if (!surveyInProgress) {
    return defaultText;
  }

  var survey = store.getters['surveys/survey'];
  var labels = (_survey = survey(surveyInProgress)) === null || _survey === void 0 ? void 0 : _survey.labels;

  if (!labels) {
    return defaultText;
  }

  var lang = labels ? labels.find(function (obj) {
    return obj.ref === key;
  }) : defaultText;

  if (lang == null || _typeof(lang) !== 'object') {
    return defaultText;
  }

  if ((lang === null || lang === void 0 ? void 0 : lang.type) == 'text') {
    return this.$options.filters.nl2br((lang === null || lang === void 0 ? void 0 : lang.text) || defaultText);
  }

  return lang.text || defaultText;
}

Vue.prototype.$lang = lang;
export { i18n, lang };